export default __webpack_public_path__ + "static/media/blankAvatar.9294ad14.jpeg";